import { defineComponent } from "vue";
import common from "../core/core";
import { homePageComponent } from "@/services/home-page.component";

enum BannerMode {
  left = "left",
  right = "right",
}

export default defineComponent({
  components: {},
  data() {
    return {
      addressService: this.$store.direct.getters.addressService,
      homePage: homePageComponent,
      isCityReady: false,
      cityStep: null,
      svg: null,
      stepTimeline: null,
    };
  },
  mounted() {
    this.homePage.bannerMode = BannerMode.left;
  },
  computed: {
    isStep() {
      return this.cityStep !== null;
    },
    getCityStep() {
      return this.cityStep;
    },
    getCityStepName() {
      return this.cityStep === null ? null : "step" + this.cityStep;
    },
  },
  methods: {
    getTariffPrice(price: number, tvPrice: number) {
      return this.homePage.tvTariff ? tvPrice : price;
    },
    getTariffItem(value: any, tvValue: any) {
      return this.homePage.tvTariff ? tvValue : value;
    },

    async toggleBannerMode(mode: BannerMode) {
      await this.setStep(null);
      this.homePage.bannerMode = mode;
    },
    async setStep(step: number | null) {
      if (step === this.cityStep) {
        return true;
      }
      let requiredChangeBannerMode: BannerMode = null;
      if (step !== null && step <= 3 && this.homePage.bannerMode == BannerMode.right) {
        requiredChangeBannerMode = BannerMode.left;
      }
      if (step !== null && step >= 4 && this.homePage.bannerMode == BannerMode.left) {
        requiredChangeBannerMode = BannerMode.right;
      }
      if (requiredChangeBannerMode) {
        await this.toggleBannerMode(requiredChangeBannerMode);
      }
      const oldStep = this.cityStep;
      this.cityStep = step;
    },
    isPopup(index: number) {
      return index === this.cityStep;
    },
    skipIntro() {
      const page: any = document.querySelector(".page-content");
      const menu: any = document.querySelector(".top_menu");

      window.scrollTo({
        top: page?.offsetTop - menu?.offsetHeight - 40,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  mixins: [common],
});
